import { useDestinationContext } from '@/src/contexts'

import CostOfLiving from './costOfLiving'

const CostOfLivingWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const col = sections.costOfLiving
    if (!col) return null

    const priceRows = [
        { label: 'Budget meal', value: col.budgetMealEstimate },
        { label: 'Mid-range meal', value: col.midRangeMealEstimate },
        { label: 'Public transport', value: col.publicTransportTicket },
        { label: 'Coffee shop', value: col.coffeeShop },
    ].filter(r => r.value)

    const infoFacts = [
        col.currency ? { label: 'Currency', value: `${col.currency.name} (${col.currency.code})` } : null,
        { label: 'Language', value: col.language?.official },
        { label: 'Timezone', value: col.timezone ? `${col.timezone} (UTC${col.utcOffset})` : undefined },
    ].filter((r): r is { label: string; value: string } => !!r?.value)

    return (
        <CostOfLiving
            priceRows={priceRows}
            infoFacts={infoFacts}
            tipping={col.tipping}
            currencySymbol={col.currency?.symbol}
        />
    )
}

export default CostOfLivingWrapper
